<template>
  <div>
    <h1 class="page-header">{{ $t('payOvertimeRuleByShift.pageTitle') }}</h1>
    <div>
      <ts-card>
        <ts-card-wrapper>
          <div class="d-flex justify-content-between">
            <ts-button color="info" outline @click="showForm()">{{ $t('addNew') }}</ts-button>
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 300px;" />
          </div>
        </ts-card-wrapper>
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.shift ? record.shift.shift_name : '' }}</td>
            <td>{{ record.keyword }}</td>
            <td>{{ record.overtime_item ? record.overtime_item.ot_name : '' }}</td>
            <td>{{ record.time_from }}</td>
            <td>{{ record.time_to }}</td>
            <td>{{ record.remarks }}</td>
            <td class="text-center">
              <a href="#" v-tooltip="$t('tooltip.edit')" class="text-primary mr-2" @click.prevent="edit(record)">
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('tooltip.delete')"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
        <div class="d-flex justify-content-end p-15">
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
      </ts-card>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FormComponent from './form.vue'

export default {
  name: 'pay-overtime-rule-by-shift',
  components: { FormComponent },
  data() {
    return {
      loading: false
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/payOvertimeRuleByShift', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.hr.payOvertimeRuleByShift.search
      },
      set(newValue) {
        this.$store.commit('hr/payOvertimeRuleByShift/SET_SEARCH', newValue)
        this.$store.commit('hr/payOvertimeRuleByShift/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('payOvertimeRuleByShift.shiftName'),
          sortKey: 'shift.shift_name'
        },
        {
          name: this.$t('payOvertimeRuleByShift.keyword'),
          sortKey: 'keyword'
        },
        {
          name: this.$t('payOvertimeRuleByShift.otName'),
          sortKey: 'overtime_item.ot_name'
        },
        {
          name: this.$t('payOvertimeRuleByShift.timeFrom'),
          sortKey: 'time_from'
        },
        {
          name: this.$t('payOvertimeRuleByShift.timeTo'),
          sortKey: 'time_to'
        },
        {
          name: this.$t('payOvertimeRuleByShift.remarks'),
          sortKey: 'remarks'
        },
        { name: this.$t('actions'), style: 'text-align:center; width: 1px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('hr/payOvertimeRuleByShift/fetch', { include: 'shift,overtime_item', ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(record) {
      this.showForm(record)
    },
    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('hr/payOvertimeRuleByShift/destroy', record.id)
          .then(response => {
            this.fetchData()
            this.$toasted.success(response.message)
            record._deleting = false
          })
          .catch(error => {
            this.$toasted.error(error.message)
            record._deleting = false
          })
      }
    },
    showForm(editData) {
      this.$modal.show(
        FormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '700px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/payOvertimeRuleByShift/RESET_STATE')
    next()
  }
}
</script>
